<template>
    <div>
        <div class="vx-row">
            <div class="vx-col w-full mb-base">
                <div class="vx-card">
                    <div class="vx-card__header">
                        <div class="vx-card__title">
                            <h4 class="mb-4">Users</h4>
                        </div>
                    </div>
                    <div class="vx-row">
                        <div class="vx-col mb-base">
                            <vs-input id="search-box-users" v-on:input="filterChangedUsers" icon="search" size="large"
                                      v-model="searchInputUsers"
                                      label-placeholder="Search"
                                      class="ml-6 mt-6"/>
                        </div>
                        <div class="vx-col mb-base grid-filter-icon-wrapper" v-on:click="showFilters = !showFilters">
                            <feather-icon icon="FilterIcon" svgClasses="w-6 h-6 mt-6"/>
                        </div>
                    </div>

                    <div v-if="getUsers && getUsers.length > 0" class="vx-row ml-6"
                         v-bind:class="{'mb-base': showFilters}">
                        <vs-checkbox class="mr-6" v-on:change="setActiveStatus('active', $event)"
                                     v-model="showMembActive">
                            Active membership
                        </vs-checkbox>
                        <vs-checkbox v-on:change="setActiveStatus('not-active', $event)" v-model="showMembInactive">
                            Inactive membership
                        </vs-checkbox>
                    </div>

                    <div class="vx-row ag-grid-columns-filter-wrapper" v-bind:class="{ show: showFilters}">
                        <div class="vx-col ml-6">
                            <span v-for="(column, index) in columnsFilter" v-bind:key="index"
                                  class="filter-checkbox-wrapper mb-2">
                                <vs-checkbox v-model="column.show"
                                             @change="setColumnsVisibility()">{{ column.name }}</vs-checkbox>
                            </span>
                        </div>
                    </div>
                    <ag-grid-vue
                        class="ag-theme-material w-100 mb-4 ag-grid-table clickable-grid"
                        :columnDefs="usersListColumns"
                        :rowData="getUsers"
                        :defaultColDef="defaultColDef"
                        :gridOptions="gridOptions"
                        rowSelection="multiple"
                        @rowClicked="onUserRowSelected"
                        colResizeDefault="shift"
                        :animateRows="true"
                        :pagination="true"
                        :paginationPageSize="paginationPageSize"
                        :suppressPaginationPanel="true"
                        :isExternalFilterPresent="isExternalFilterPresent"
                        :doesExternalFilterPass="doesExternalFilterPass"
                        v-on:gridReady="setGridSize($event)">
                    </ag-grid-vue>
                    <vs-pagination
                        :total="totalPages"
                        :max="paginationMaxSize"
                        v-model="currentPage"/>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import RestService from '../services/RestService';
import {AgGridVue} from 'ag-grid-vue';
import '../assets/scss/vuexy/extraComponents/agGridStyleOverride.scss';
import CellRendererDate from './cell-renderer/CellRendererDate';
import CellRendererValue from './cell-renderer/CellRendererValue';
import CellRendererMembership from './cell-renderer/CellRendererMembership';
import CellRendererAvatar from './cell-renderer/CellRendererAvatar';
import UserData from "../layouts/components/UserData";

export default {
    name: "members-list",
    components: {
        UserData,
        AgGridVue,
        CellRendererDate,
        CellRendererValue,
        CellRendererMembership,
        CellRendererAvatar
    },
    watch: {
        async $route() {
            await this.checkAvailableUserData();
        },
    },
    async beforeMount() {
        if (!this.userUuid) {
            this.userUuid = this.$route.query.uuid;
        }

        const usersResponse = await RestService.getAllUsers();
        if (usersResponse.success) {
            this.usersList = usersResponse.data;
        }

        if (!this.listOfReferrers && this.userUuid) {
            await this.getUsersReferrals();
        }

        await this.checkAvailableUserData();
    },
    methods: {
        async checkAvailableUserData() {
            if (!this.gridApi) {
                this.gridApi = this.gridOptions.api;
            }

            this.userUuid = this.$route.query.uuid;

            if (!this.userName && this.userUuid) {
                let user = this.usersList.find((el) => {
                    return el.uuid === this.userUuid;
                });
                this.userName = user.first_name + ' ' + user.last_name;
            }
        },

        setGridSize(params) {
            //TODO add vertical menu width
            if (window.innerWidth > this.getTotalWidth())
                params.api.sizeColumnsToFit();
            this.gridOptions.api.setDomLayout('autoHeight');
        },

        getTotalWidth() {
            let width = 0;
            this.usersListColumns.forEach(c => {
                if (c.width)
                    width += c.width;
                else
                    width += this.defaultColDef.width;
            });
            return width;
        },

        async onUserRowSelected(event) {
            this.userUuid = event.node.data.uuid;
            this.userName = event.node.data.first_name + ' ' + event.node.data.last_name;

            await this.getUsersReferrals();

            await this.$router.push({path: '/admin/members/user', query: {uuid: event.node.data.uuid}});
        },

        async getUsersReferrals() {
            const referrersResponse = await RestService.getUsersReferrals(this.userUuid);
            if (referrersResponse.success)
                this.listOfReferrers = referrersResponse.data.referrals;
        },

        filterChangedUsers() {
            this.gridApi.setQuickFilter(document.getElementById('search-box-users').value);
        },

        setColumnsVisibility() {
            this.columnsFilter.forEach(c => {
                this.gridOptions.columnApi.setColumnVisible(c.id, c.show);
            });
            // TODO this needs optimization
            if (window.innerWidth > this.getTotalWidth())
                this.gridApi.sizeColumnsToFit();
        },

        setActiveStatus(value, event) {
            if (value === 'active') {
                this.showMembActive = event.target.checked;
            } else {
                this.showMembInactive = event.target.checked;
            }

            if (this.showMembInactive && this.showMembActive) {
                this.activeFilterChanged('all');
            } else if (this.showMembActive && !this.showMembInactive) {
                this.activeFilterChanged('active');
            } else if (!this.showMembActive && this.showMembInactive) {
                this.activeFilterChanged('not-active');
            } else {
                this.activeFilterChanged('null');
            }
        },

        activeFilterChanged(newVal) {
            this.membStatus = newVal;

            if (this.gridApi) {
                this.gridApi.onFilterChanged();
            }
        },

        isExternalFilterPresent() {
            return this.membStatus !== 'all';
        },

        doesExternalFilterPass(node) {
            switch (this.membStatus) {
                case 'active':
                    return node.data.active === true
                case 'not-active':
                    return node.data.active === false
                case 'null':
                    return false;
                default:
                    return true;
            }
        },
    },
    computed: {
        refereesData() {
            return this.listOfReferrers;
        },
        getUsers() {
            return this.usersList;
        },
        paginationPageSize() {
            return 10; // TODO maybe change
        },
        paginationMaxSize() {
            if (this.gridApi) {
                let pagesNr = this.gridApi.paginationGetTotalPages();
                return pagesNr < 8 ? pagesNr + 1 : 7; // TODO maybe change this
            } else
                return 1;
        },
        totalPages() {
            if (this.gridApi)
                return this.gridApi.paginationGetTotalPages();
            else
                return 0;
        },
        currentPage: {
            get() {
                if (this.gridApi)
                    return this.gridApi.paginationGetCurrentPage() + 1;
                else
                    return 1;
            },
            set(val) {
                this.gridApi.paginationGoToPage(val - 1);
            }
        },
        currency() {
            return this.$store.state.currency;
        }
    },
    mounted() {
        this.gridApi = this.gridOptions.api;
        this.columnsFilter = this.usersListColumns.map(c => {
            return {id: c.field, name: c.headerName, show: true};
        });
    },
    data() {
        return {
            gridOptions: {},
            gridApi: null,
            pendingList: null,
            usersList: null,
            usersCount: 0,
            requestsCount: 0,
            currentMoney: 0,
            pendingRequestsNum: 0,
            monthRevenue: 0,
            yearRevenue: 0,
            monthPayout: 0,
            yearPayout: 0,
            pendingPayout: 0,
            pendingRequest: 0,
            userUuid: null,
            userName: null,
            usersListColumns: [
                {
                    headerName: 'First name',
                    field: 'first_name',
                },
                {
                    headerName: 'Last name',
                    field: 'last_name',
                },
                {
                    headerName: 'Email',
                    field: 'email',
                },
                {
                    headerName: 'Referral ID',
                    field: 'uuid',
                    width: 400
                },
                {
                    headerName: 'Balance',
                    field: 'balance',
                    cellClass: 'text-center',
                    cellRendererFramework: 'CellRendererValue',
                    width: 200
                },
                {
                    headerName: 'Membership status',
                    field: 'active',
                    cellClass: 'text-center',
                    cellRendererFramework: 'CellRendererMembership',
                },
                {
                    headerName: 'Registered',
                    field: 'created_at',
                    cellRendererFramework: 'CellRendererDate',
                    //width: 300
                }
                // {
                //     headerName: 'Invited',
                //     field: 'invited',
                //     filter: true,
                //     width: 300
                // }
            ],
            defaultColDef: {
                sortable: true,
                editable: false,
                resizable: true,
                suppressMenu: true,
                width: 300
            },
            columnDefs: null,
            rowData: null,
            columnsFilter: [],
            showFilters: false,
            listOfReferrers: null,
            membStatus: 'all',
            showMembActive: true,
            showMembInactive: true,
            searchInputUsers: '',
            referrerComponents: {
                CellRendererAvatar
            }
        }
    }
}
</script>
